import React from 'react'
import * as Clipboard from '../../../utils/clipboard'

const Component = (props) => {
    return (
        <div
            onClick={() => {
                Clipboard.copyText(
                    props.text,
                    () => {
                        if (props.onSuccess) props.onSuccess()
                    },
                    () => {
                        if (props.onFailed) props.onFailed()
                    }
                )
            }}
        >
            {props.children}
        </div>
    )
}

export default Component
